import { DataSource, Layout, Table, } from "@mcleod/components";

export abstract class AutogenLayoutOrderAgentPayee extends Layout {
    sourceOrderAgentPayee: DataSource;
    table1: Table;
}
